import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import en from './en.json'
import it from './it.json'

export const resources = {
  it_IT: { translation: it },
  en_US: { translation: en },
} as const

const detectionOptions = {
  order: ['localStorage'],
  lookupLocalStorage: 'ai-go-studio:lng',
  caches: ['localStorage'],
}

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    detection: detectionOptions,
    resources,
    fallbackLng: 'en_US',
    supportedLngs: ['en_US', 'it_IT'],
    keySeparator: false,
    nsSeparator: false,
    interpolation: {
      escapeValue: false,
    },
  })

declare module 'react-i18next' {
  type DefaultResources = typeof resources['en_US']
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface Resources extends DefaultResources {}
}
